const getLessonSubject = lesson => {
  return lesson.subject
    ? lesson.subject.name + ' - ' + lesson.name
    : lesson.name
}

export default getLessonSubject
